import React from 'react';

import { PersonAvatar } from './PersonAvatar';

type PersonBylineProps = {
  name: string;
  role: string;
  image?: string;
};

export const PersonByline: React.FC<PersonBylineProps> = ({ name, role, image }) => {
  return (
    <div className="d-inline-flex align-items-center position-relative me-3">
      <PersonAvatar name={name} src={image} size="sm" className="me-3" />
      <div>
        <span className="nav-link p-0 fw-bold text-decoration-none stretched-link">{name}</span>
        <span className="fs-sm text-muted person-role">{role}</span>
      </div>
    </div>
  );
};
